export default {
  items: [],
  itemsCount: 0,
  query: '',
  limit: 10,
  skip: 0
}
